import { CollapseButton, CollapseWrapper } from "./styled"
import { Collapse as MuiCollapse, SxProps } from '@mui/material'
import { useState } from "react"
import ArrowExpandIcon from "components/icons/other/arrow-expand"
import Tooltip from "../tooltip"

type Props = {
  label?: string,
  children: React.ReactNode,
  disablePadding?: boolean,
  tooltip?: string,
  sx?: SxProps
}

const Collapse = ({ label, children, disablePadding, tooltip, sx }: Props) => {

  const [ open, setOpen ] = useState(false)

  return (
    <CollapseWrapper sx={sx}>
      <CollapseButton open={open} onClick={() => setOpen(!open)}>
        <ArrowExpandIcon className="arrow"/>
        { label }
        <Tooltip title={tooltip} />
      </CollapseButton>
      <MuiCollapse timeout={200} sx={disablePadding? {  }: { pl: 4 }} in={open}>
        { children }
      </MuiCollapse>
    </CollapseWrapper>
  )
}

export default Collapse